module.exports = __webpack_public_path__ + "static/media/milica.019ffaca.JPG";